var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCilBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1175 6.05742H18.1482V1.44922H7.37669V6.05742H2.41858C2.10249 6.05783 1.79946 6.18358 1.57596 6.4071C1.35245 6.63061 1.22671 6.93364 1.22632 7.24973V23.329C1.22673 23.6451 1.35247 23.9481 1.57597 24.1716C1.79948 24.3951 2.10249 24.5209 2.41858 24.5213H23.1175C23.4336 24.5209 23.7366 24.3951 23.9601 24.1716C24.1836 23.9481 24.3093 23.6451 24.3098 23.329V7.24973C24.3094 6.93364 24.1836 6.63061 23.9601 6.4071C23.7366 6.18358 23.4336 6.05783 23.1175 6.05742ZM8.91707 2.9896H16.6078V6.05742H8.91707V2.9896ZM22.6954 7.67184V11.5366L20.1356 14.0963H13.5752V11.8468H11.9609V14.0963H5.40042L2.84064 11.5366V7.67184H22.6954ZM2.84064 22.907V13.8196L4.73175 15.7107H11.9609V17.9843H13.5752V15.7107H20.8043L22.6954 13.8196V22.907H2.84064Z",
    fill: "#0073FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilBriefcase);
export default __webpack_public_path__ + "static/media/cil_briefcase.2154431397597ed5cbd692984fadc781.svg";
export { ForwardRef as ReactComponent };